import { createUseStyles } from 'react-jss';
import { PricingAppTheme } from '~app/styles/theme';
import { MD_MEDIA_QUERY } from '~shared/media-query';

type Props = {
  packageName: string;
};

export default createUseStyles(({ pricingPalette, packageTheme, spacing }: PricingAppTheme) => ({
  CTA: {
    margin: `${spacing[6]}px  auto`,
    display: 'flex',
    justifyContent: 'center',
    '& a': {
      maxWidth: 200,
      width: '70%',
      backgroundColor: ({ packageName }: Props) => packageTheme[packageName]?.primary,
      border: 'none',
      '&:hover, &:focus': {
        backgroundColor: ({ packageName }: Props) => packageTheme[packageName]?.primary,
      },
    },
    [MD_MEDIA_QUERY]: {
      margin: ['auto', 0, 0],
    },
  },
  noCTA: {
    margin: `${spacing[6]}px  auto`,
    display: 'flex',
    justifyContent: 'center',
    background: 'none',
    border: 'none',
    '& button': {
      color: pricingPalette.colors.black,
    },
    [MD_MEDIA_QUERY]: {
      margin: ['auto', 0, 0],
    },
  },
}));
